export default class Weather {
    constructor() {
        if ($('[data-trigger="wpiris-switch"][data-scope="temperature_unit"]').length > 0) {
            import('../components/weather' /* webpackChunkName: "scripts/weather" */).then(
                ({ default: WeatherCpnt }) => {
                    new WeatherCpnt()
                },
            )
        }
    }
}
